import React, { Component } from 'react';
import { Form, Label } from 'tinper-bee';
import { observer } from "mutants-microfx"
import { Keyboard, Input, Ticon, hotKey } from 'tplus-components-touch'
import { platform } from 'mutants-util';
import DatePicker from 'bee-datepicker';
import moment from 'moment'
import tools from '../../../util/tools';
import config from '../../../config'

const commonDateFormat = 'YYYY-MM-DD';
const minDate = config.minDate;
const FormItem = Form.FormItem;

@observer
class ModalForm extends React.Component {
  // curFieldModel ：键盘要改变的数据
  // input :当前键盘绑定的dom

  constructor(props) {
    super(props)
    const { isHorizontalPad, isHorizontalSunMi } = platform || {};
    this.isHorizontalPad = !!isHorizontalPad;
    this.isHorizontalSunMi = !!isHorizontalSunMi;
  }

  componentDidMount() {
    if (this.isHorizontalPad) return;
    setTimeout(() => {
      const modal = document.getElementsByClassName('modal-form-content')[0];
      if (!modal) return;
      const inputs = modal.getElementsByTagName('input');
      let input = inputs && [...inputs].filter(v => v.disabled == false && v.style.display != 'none');
      input = input && input.length > 0 ? input[0] : null;
      if (this.isHorizontalSunMi) {
        if (input) setTimeout(() => { input.focus() }, 250)
      } else {
        if (input) input.focus();
      }
    }, 0)
  }

  textBoxChange = (value, curFieldModel) => {
    this.props.changeValue(this.curFieldModel, value);
  }

  triggerChange = (value, fieldModel) => {
    const { changeValue } = this.props;
    changeValue && changeValue(fieldModel, value)
  }

  triggerOk = () => {
    const { ok } = this.props;
    ok && ok()
  }

  onKeyDown = (e, el) => {
    if (!e) return;
    let input = e.target;
    const key = e.keyCode;
    if (key === 13) {
      let inputs = $.find_element('input');
      if (!inputs) return;
      let length = inputs.length;
      if (length == 0) return;
      let index = inputs && inputs.findIndex(v => v == input);
      if (index == length - 1) {
        this.triggerOk();
        setTimeout(() => { input && input != document.activeElement && input.focus() }, 0)
      } else {
        input = inputs[index + 1];
        input && input != document.activeElement && input.focus();
      }
    }
  }

  checkoutVal = (val) => {
    if (this.curFieldModel.ControlType === 'NumTextBox') {
      if ('maxLength' in this.curFieldModel) {
        if (this.curFieldModel.maxLength < val.length) return false;
      }
      var arr = val.split('.');
      if (arr.length > 2) { return false }
      if ('precisionLength' in this.curFieldModel) {
        if (arr.length == 2 && arr[1].length > this.curFieldModel.precisionLength) {
          return false;
        }
      }
    }
    return true;
  }

  disabledDate = (current) => {
    return current && current.valueOf() < minDate.getTime()
  }

  render() {
    const { getFieldProps } = this.props.form;
    const { modalType } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const getRuleConfig = (el) => {
      return {
        rules: [{
          required: el.IsRequired, message: `请录入${el.Title}`
        }]
      }
    }
    const { data } = this.props;

    return (
      <Form ref={(dom) => { this.container = dom }} {...formItemLayout} className={modalType === 'small' ? 'u-form-around' : ''}>
        <input type="text" style={{ display: 'none' }}></input>
        {
          data.map((el, index) => {
            let styles = index == data.length - 1 ? { inputClassName: hotKey.hotKeyNotFilter('form-input') } : {};
            if (el.ControlType === 'TextBox' || el.ControlType === 'NumTextBox' || el.ControlType === 'PwdTextBox') {
              let type = el.ControlType === 'PwdTextBox' ? 'password' : 'text';
              return (
                <FormItem
                  label={el.Title}
                  hasFeedback
                  key={index}
                  style={el.SingleShow ? {
                    'height': '35px',
                    'minHeight': '35px'
                  } : {}}
                >
                  <Input
                    {...styles}
                    State={el.State}
                    Label={el.Label}
                    Title={el.Title}
                    Value={el.Value}
                    IsScan={!!el.IsScan}
                    IsReturn={el.isReturn}
                    SingleShow={el.SingleShow}
                    ControlType={el.ControlType}
                    disabled={el.disabled}
                    Style={el.Style}
                    placeholder={el.placeholder}
                    type={type}
                    type1={el.type}
                    maxLength={el.maxLength}
                    precisionLength={el.precisionLength}
                    onChange={e => {
                      if (el.ControlType === 'NumTextBox') {
                        this.textBoxChange(e, el)
                      } else {
                        this.textBoxChange(e.target.value, el)
                      }
                    }}
                    handleChange={value => this.triggerChange(value, el)}
                    handleOk={this.triggerOk}
                    max={el.max}
                    min={el.min}
                    onFocus={(e) => {
                      this.curFieldModel = el;
                      if (el.ControlType === 'NumTextBox') {
                        this.input = e;
                        Keyboard.close();
                        return
                      }
                      this.input = e.target;
                      Keyboard.open((v) => {
                        let value = Keyboard.getNewValue(this.input, this.input.value, v);
                        this.textBoxChange(value)
                      })()
                    }}
                    onKeyDown={e => this.onKeyDown(e, el)}
                  />
                </FormItem>
              )
            } else if (el.ControlType === 'TextArea') {
              styles = index == data.length - 1 ? { className: hotKey.hotKeyNotFilter('form-input') } : {};
              return (
                <FormItem
                  label={el.Title}
                  hasFeedback
                  key={index}
                >
                  {
                    el.Title
                      ?
                      <Label style={{ 'verticalAlign': 'top' }}>{el.Title}:</Label>
                      :
                      null
                  }
                  <textarea
                     {...styles}
                    style={el.Title ? { width: '240px' } : { width: '368px' }}
                    maxLength='50'
                    rows='2'
                    value={el.Value}
                    onChange={(e) => { this.textBoxChange(e.target.value, el) }}
                    onFocus={(e) => {
                      this.input = e.target;
                      this.curFieldModel = el;
                      Keyboard.open((v) => {
                        let value = Keyboard.getNewValue(this.input, this.input.value, v);
                        this.textBoxChange(value)
                      })()
                    }}
                    onKeyDown={e => this.onKeyDown(e, el)}
                  />
                </FormItem>
              )
            } else if (el.ControlType === 'DatePicker') {
              return (
                <FormItem
                  label={el.Title}
                  hasFeedback
                  key={index}
                >
                  <div className='input-wrapper-2'>
                    <Label style={{ 'lineHeight': '50px' }}>
                      {el.Title}:
                    </Label>
                    <DatePicker
                      renderIcon={() => { return <Ticon type='riqi' className='riqi' /> }}
                      format={commonDateFormat}
                      placeholder={el.placeholder}
                      disabledDate={this.disabledDate}
                      showClose={false}
                      keyboardInput={false}
                      enterKeyDown={false}
                      outInputFocus={(e) => {
                        const input = e && e.target;
                        input.select();
                        Keyboard.close();
                      }}
                      onKeyDown={e => this.onKeyDown(e, el)}
                      {
                        ...getFieldProps(el.FieldName, getRuleConfig(el))
                      }
                    />
                  </div>
                </FormItem>
              )
            }
          })
        }
      </Form>
    )
  }
}
//输入datepicker控制；
const handdleDate = (value) => {
  if (tools.isNull(value)) {
    value = "";
    return value;
  }

  if (!(value instanceof moment)) {
    value = moment(value)
  }

  if (value && value.valueOf() < minDate.getTime()) {
    value = "";
  }
  return value;
}
const WrappedModalForm = Form.createForm({
  name: 'modalForm',
  mapPropsToFields(props) {
    let obj = {}
    props.data.forEach((el) => {
      let value = el.Value;
      if (el.ControlType == 'DatePicker') {
        value = handdleDate(value)
      }
      obj[el.FieldName] = Form.createFormField({
        value: value,
      })
    })
    return obj;
  },
  onFieldsChange(props, fields) {
    for (let key in fields) {
      props.data.forEach((el) => {
        if (el.FieldName !== key) return;
        let fieldValue = fields[key].value;
        if (el.ControlType == 'DatePicker') {
          let oldValue = el.Value;
          if (!oldValue) oldValue = new Date(1899, 0, 1);
          if (!fieldValue) {
            fieldValue = new Date(1899, 0, 1);
          } else {
            fieldValue = new Date(fieldValue.format('YYYY/MM/DD'));
          }
          if (moment(fieldValue).format('YYYY-MM-DD') === moment(oldValue).format('YYYY-MM-DD')) {
            return;
          }
        }
        props.changeValue(el, fieldValue)
      })
    }
  }
})(ModalForm);
export default WrappedModalForm;